exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bottomView___3kS-4 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 92%;\n  position: fixed;\n  bottom: 0;\n  background: #fff;\n  padding: 20px 0 ;\n}\n.bottomView___3kS-4 .am-button {\n  line-height: 48px !important;\n}\n.btn___1Mupi {\n  width: 205px;\n  height: 48px;\n  background-color: #004CE3;\n}\n.btn___1Mupi span {\n  color: #ffffff !important;\n}\n.btnBlack___7RgvD {\n  width: 120px;\n  height: 48px;\n}\n.btnBlack___7RgvD span {\n  color: #20304b !important;\n}\n", ""]);

// exports
exports.locals = {
	"bottomView": "bottomView___3kS-4",
	"btn": "btn___1Mupi",
	"btnBlack": "btnBlack___7RgvD"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/routes/author/contract/signActionSheet.less
// module id = 949
// module chunks = 0